module.exports = __webpack_public_path__ + "static/media/bg-desktop.95c8d5a1.png";